/* eslint-disable no-undef */
import '@fancyapps/fancybox'

$(function () {
  $('[data-fancybox]').fancybox({
    buttons: ['slideShow', 'fullScreen', 'download', 'thumbs', 'close'],
  })
})
